var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('find-component',{attrs:{"member-type":`tempPassword`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }